export default {
    name: 'click-outside',
    wireup: {
        bind: function (el, binding, vnode) {
            let happening = false

            el.event = function (event) {
                // check to ensure we're not inside the target element
                // we have to start and stop the click process outside of the target
                // so we use mousedown and mouseup instead of just click
                // click will catch if you start clicking inside the element and finish
                // clicking outside, which isn't ideal if you're trying to select text
                if (document.contains(event.target) && !(el == event.target || el.contains(event.target))) {
                    if (event.type == 'mousedown') {
                        happening = true
                    } else if (happening && event.type == 'mouseup') {
                        if (typeof vnode.context[binding.expression] === 'function') {
                            vnode.context[binding.expression](event)
                        } else if (typeof binding.value === 'function') {
                            binding.value(event)
                        }
                    } else {
                        happening = false
                    }
                } else {
                    happening = false
                }
            }
            document.body.addEventListener('mousedown', el.event)
            document.body.addEventListener('mouseup', el.event)
        },
        unbind: function (el) {
            document.body.removeEventListener('mousedown', el.event)
            document.body.removeEventListener('mouseup', el.event)
        },
    },
}
